export default __webpack_public_path__ + "static/media/home2.5acf3e91.jpg";